import React, { useState } from 'react';
import PageContainer from 'components/PageContainer/PageContainer';
import { IFormato, IFormulario, SuscripcionBoletin } from 'utils/models/interfaces';
import { tooltips } from 'utils/formData';
import { useError } from 'services/ErrorContext';
import { enviarMailRestablecer } from 'services/servicioPost';
import { alturaContainer, anchoMaxForms } from 'utils/constants';
import { HowToReg } from '@mui/icons-material';
import { Box } from '@mui/material';
import Formulario from '../Formulario/Formulario';

const RestablecerPassSolicitud = () => {
  const [mensajeExito, setMensajeExito] = useState('');
  const { error, clearError, loading, setError, setLoading } = useError();

  const datosFormContactoLogueado: IFormato<SuscripcionBoletin>[] = [
    {
      name: 'email',
      label: 'Email',
      inputType: 'email',
      adornment: 'email',
      pattern: tooltips.email.pattern,
      tooltip: tooltips.email.tooltip,
      subtituloSeccion: 'Ingresá tu correo electrónico',
    },
  ];

  async function handleSubmit(data: IFormulario): Promise<void> {
    clearError();

    const request = {
      email: data.email,
    };

    try {
      await enviarMailRestablecer(request, setError, setLoading);
      setMensajeExito(`¡Solicitud de restablecimiento enviada con éxito!`);
    } catch (err) {
      setError('Ocurrió un error. Es posible que no exista un usuario con ese correo.');
    }
  }

  const handleVolver = () => {
    setMensajeExito('');
  };

  return (
    <PageContainer marginBottom={true}>
      <Box minHeight={alturaContainer} maxWidth={anchoMaxForms} mx="auto">
        <Formulario
          campos={datosFormContactoLogueado}
          titulo="Restablecer contraseña"
          tituloPequenio={true}
          onSubmit={handleSubmit}
          onVolver={handleVolver}
          mensajeExito={mensajeExito}
          mensajeError={error}
          loading={loading}
          iconoBoton={HowToReg}
        />
      </Box>
    </PageContainer>
  );
};

export default RestablecerPassSolicitud;
